module.exports = __webpack_public_path__ + "img/colorconnectedness.d4569beb.png";